
export const SectionHeading = ({ title, description }: { title: string, description: string }) => {
    return (
        <div className="py-2 grow mb-4">
            <p className="font-semibold text-sm uppercase">{title}</p>
            <p className="text-gray-500">{description}</p>
        </div>
    )
}
